export async function getBrowserFingerprint() {
  try {
    const parts = [
      navigator.userAgent,
      `${screen.width}x${screen.height}x${screen.colorDepth}`,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      navigator.language,
      String(navigator.hardwareConcurrency || 0),
      String(navigator.deviceMemory || 0),
    ];

    // Canvas fingerprint — differs by GPU/driver/OS font rendering
    try {
      const c = document.createElement('canvas');
      const ctx = c.getContext('2d');
      ctx.textBaseline = 'top';
      ctx.font = '14px Arial';
      ctx.fillStyle = '#7C5CF6';
      ctx.fillRect(0, 0, 2, 2);
      ctx.fillText('ikhua\u{1F310}', 2, 2);
      parts.push(c.toDataURL().slice(-80));
    } catch { /* ignore */ }

    // WebGL renderer — unique per GPU
    try {
      const gl = document.createElement('canvas').getContext('webgl');
      const ext = gl?.getExtension('WEBGL_debug_renderer_info');
      if (ext) parts.push(gl.getParameter(ext.UNMASKED_RENDERER_WEBGL));
    } catch { /* ignore */ }

    const encoded = new TextEncoder().encode(parts.join('||'));
    const buf     = await crypto.subtle.digest('SHA-256', encoded);
    return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return null;
  }
}
